import { useTranslation } from 'react-i18next';
import { getWeekDaysAbbreviations } from 'utils/helpers';
import { AvailabilitiesCalendarHeaderContainer, CalendarHeaderDay } from './styles';

const AvailabilitiesCalendarHeader = (): JSX.Element => {
  const [t] = useTranslation();

  const weekDaysNames = getWeekDaysAbbreviations();

  const findRightTranslation = (dayAbr: string) => {
    switch (dayAbr) {
      case 'Mon':
        return weekDaysNames[0];
      case 'Tue':
        return weekDaysNames[1];
      case 'Wed':
        return weekDaysNames[2];
      case 'Thu':
        return weekDaysNames[3];
      case 'Fri':
        return weekDaysNames[4];
      case 'Sat':
        return weekDaysNames[5];
      default:
        return weekDaysNames[6];
    }
  };

  return (
    <AvailabilitiesCalendarHeaderContainer>
      <CalendarHeaderDay>{findRightTranslation('Mon')}</CalendarHeaderDay>
      <CalendarHeaderDay>{findRightTranslation('Tue')}</CalendarHeaderDay>
      <CalendarHeaderDay>{findRightTranslation('Wed')}</CalendarHeaderDay>
      <CalendarHeaderDay>{findRightTranslation('Thu')}</CalendarHeaderDay>
      <CalendarHeaderDay>{findRightTranslation('Fri')}</CalendarHeaderDay>
      <CalendarHeaderDay>{findRightTranslation('Sat')}</CalendarHeaderDay>
      <CalendarHeaderDay>{findRightTranslation('Sun')}</CalendarHeaderDay>
    </AvailabilitiesCalendarHeaderContainer>
  );
};

export default AvailabilitiesCalendarHeader;
